const onLoadScript = (resolve: (value: Event | PromiseLike<Event>) => any) => {
  const loadEvent = (dis: GlobalEventHandlers, ev: Event) => {
    return resolve(ev);
  };
  return loadEvent;
};

export const downloadScript = async (url) => {
  let promis = new Promise<Event>((resolve, reject) => {
    const scriptTag = document.createElement('script');
    scriptTag.src = url;
    scriptTag.onload = onLoadScript(resolve) as any;
    document.head.appendChild(scriptTag);
    // console.log('script', url);
  });

  // scriptTag.onreadystatechange = implementationCode;

  return await promis;
};